import * as types from "../../constants/index"
let mix = JSON.parse(window.localStorage.getItem("mix"))
console.log("======================本地存储的混音状况==============", mix)
export default {
  state: {
    audioLeval: 0,
    audioStatus: true, // 是否开启声音
    audioSettingVolume: 50, // 设置页面初始音量值
    isMixClose: mix || false // 默认开启混音,
    // isMixClose: false // 默认开启混音
  },
  mutations: {
    [types.MEDIA_AUDIO_LEVAL](state, payload) {
      state.audioLeval = payload
    },
    [types.MEDIA_AUDIO_STATUS](state, payload) {
      state.audioStatus = payload
    },
    [types.MEDIA_AUDIO_VOLUME](state, payload) {
      state.audioSettingVolume = payload
    },
    [types.CHANGE_AUDIO_MIX_STATUS](state, payload) {
      state.isMixClose = payload
    }
  },
  getters: {
    audioLeval: state => state.audioLeval,
    audioStatus: state => state.audioStatus,
    audioSettingVolume: state => state.audioSettingVolume
  }
}
